const genders = {
  male: "Man",
  female: "Vrouw",
  unknown: "Onbekend",
};

export default genders;
